module.exports = __webpack_public_path__ + "219f500a78a0d151cae63f989e7112b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-glass-house-empty.png
// module id = 329
// module chunks = 0